/**
 * Discounts Resource Client
 * Axios-based API client for discount/promotion code endpoints
 */

import { ApiClient } from './apiClient';

export interface Discount {
    id: string;
    promotionId: string;
    promotionCodeId: string | null;
    appliedAt: string;
    appliedManually: boolean;
    promotion: {
        id: string;
        name: string;
    };
}

export interface DiscountCodeValidation {
    isValid: boolean;
    code: string;
    error?: string;
    discount?: {
        id: string;
        name: string;
        type: string;
        value: number;
        currency: string;
    };
}

export interface ApplyDiscountResponse {
    success: boolean;
    error?: any;
    promotion?: Discount;
}

export interface RemoveDiscountResponse {
    success: boolean;
    error?: any;
}

export class DiscountsResource {
    constructor(private apiClient: ApiClient) { }

    /**
     * Get applied discounts for a checkout session
     */
    async getAppliedDiscounts(sessionId: string): Promise<Discount[]> {
        return this.apiClient.get(`/api/v1/checkout-sessions/${sessionId}/promotions`);
    }

    /**
     * Apply a discount code to a checkout session
     */
    async applyDiscountCode(
        sessionId: string,
        code: string,
    ): Promise<ApplyDiscountResponse> {
        return this.apiClient.post(`/api/v1/checkout-sessions/${sessionId}/promotions/apply`, {
            code: code.trim(),
        });
    }

    /**
     * Remove a discount from a checkout session
     */
    async removeDiscount(
        sessionId: string,
        discountId: string,
    ): Promise<RemoveDiscountResponse> {
        return this.apiClient.delete(`/api/v1/checkout-sessions/${sessionId}/promotions/${discountId}`);
    }
}

